import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import { useGET_studentByIdQuery } from 'redux/api/studentsApi'

import PageBody from 'components/atoms/PageBody'
import Tabs from 'components/organisms/tabs/Tabs'

import RtiRiskCriteriaList from 'components/utilized/rti/RtiRiskCriteriaList'
import RtiConcernReasonsList from 'components/utilized/rti/RtiConcernReasonsList'
import RtiInterventionList from 'components/utilized/rti/RtiInterventionList'
import RtiMeetings from 'components/utilized/rti/RtiMeetings'

import { useHash } from 'utils/customHooks/useHash'
import { Box, Button, Typography } from '@mui/material'
import { School } from '@mui/icons-material'
import RtiPlopList from 'components/utilized/rti/RtiPlopList'



const RtiStudentPage = () => {
  const { t } = useTranslation()
  const {hash} = useHash();
  const navigate = useNavigate();
  
  const params = useParams()  
  const id = params?.id
  const { data: student } = useGET_studentByIdQuery(id, {skip: !id})

  return ( <> 
      { student && <>

          <Box className="breadcrumbs" sx={{ padding: '5px 20px', marginBottom: '20px', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px', background: '#fff' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <School />
               
                <Typography sx={{ fontSize: '1rem', fontWeight: '600', marginLeft: '10px' }}>{student.first_name} {student.last_name} </Typography>
               
                <Button
                  variant='outlined'
                  color='black'
                  onClick={() => navigate(`/students/edit/${student.id}`)}
                  className='small-button'
                  sx={{ width: '120px', marginLeft: '20px' }}
                >
                  {`${t('common.go-to-profile')}`}
                </Button>

                <Button
                  variant='outlined'
                  color='black'
                  onClick={() => navigate(`/iep-students/${student.id}`)}
                  className='small-button'
                  sx={{ width: '120px', marginLeft: '20px' }}
                >
                  {`${t('common.iep-program')}`}
                </Button>

            </div>
          </Box>

          <PageBody>
            
            <Tabs tabKey={hash || 'criteria'}>
                <RtiRiskCriteriaList student={student} tabKey="criteria" tabText={`${t('rti.identfiying-academic-risk')}`} />
                <RtiConcernReasonsList student={student} tabKey="reasons" tabText={`${t('common.concern-reasons')}`} />
                <RtiPlopList student={student} tabKey="plop" tabText={`${t('common.present-level-of-performance')}`} />
                <RtiInterventionList student={student}  tabKey="interventions" tabText={`${t('common.rti-interventions')}`} />  
                <RtiMeetings student={student} tabKey="meetings" tabText={`${t('common.rti-meetings')}`} />  
            </Tabs>

          </PageBody> 

        </>
      }
    </> 
  )
}
export default RtiStudentPage